/* eslint-disable no-undef, id-length, sort-keys, max-params */

import Helper from "./Helper";

export default class MovableIncHelper {
  static sendMovableIncConversion = (purchasedProducts, totalForConversionStat, promoCode, storeName) => {
    try {
      for (let i = 0; i < purchasedProducts.length; i++) {
        const product = purchasedProducts[i];

        if (product.product_descriptor_id) {
          mitr("addProduct", {
            "sku": product.product_descriptor_id,
            "name": product.name,
            "price": Helper.formatPriceCents(product.member_price.toString()),
            "other": `Purchased from ${storeName}`
          });
        }
      }
      const purchaseInfo = {
        "revenue": totalForConversionStat,
        "identifier": `${Date.now()} - ${purchasedProducts[0].product_descriptor_id}`
      };

      const promoInfo = {"code": promoCode};

      if (promoInfo && promoInfo.code) {
        mitr("addPromo", {"code": promoInfo.code});
      }

      mitr("send", "conversion", {
        "revenue": purchaseInfo.revenue,
        "identifier": purchaseInfo.identifier
      });
    } catch (exception) {
      window.airbrake.notify(`error with movable inc helper - ${exception}`);
    }
  }
}
